module.exports = __webpack_public_path__ + "static/media/icon.d679adc9.svg";